import React, { useEffect, useState } from "react";
import Inputbox from "../../Components/Inputbox";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { DropDownManuCustom } from "../../Components/DropDownButton";
import {
  AddAddressbyagency,
  Deleteserviceaddress,
  GetPlaceservice,
  Getserviceaddress,
} from "../../../api/helper";
import { useSelector } from "react-redux";
import { ShowToast } from "../../../helpers/ToastService";
import { Box, Modal } from "@mui/material";
import { useLoadScript, Autocomplete } from "@react-google-maps/api";
import DeleteModal from "../Components/DeleteModal";
import { DateTime } from "luxon";
import timezones from 'timezones-list';

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),

  address1: Yup.string().required("Address 1 is required"),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  zip: Yup.string()
    .required("Zip is required")
    .matches(/^\d{5}$/, "Zip must be 5 digits"),
  country: Yup.string().required("Country is required"),

  serviceCode: Yup.string().required("Place of Service Code is required"), 
  locationTomeZone: Yup.string().required("Location Timezone is required"),
  phone: Yup.string().required("Phone is required"),
  email: Yup.string()
    .required("Email is required")
    .email("Invalid email format"),
  npi: Yup.string()
    .required("NPI is required")
    .matches(/^\d{10}$/, "NPI must be 10 digits"),
});

const Locationdata = timezones.map((tz) => ({
  name: tz.label, 
}));
const AddAddress = ({ GetTabStatus }) => {
  const [Placedata, setPlacedata] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [addressData, setaddressData] = useState([]);
  const profiledata = useSelector((state) => state?.cookies?.userDetails);
  const [addresstwoautocomplete, setaddresstwoautocomplete] = useState(null);
  const [addressAutocomplete, setAddressAutocomplete] = useState(null);
  const [confirmdeletemodal, setconfirmdeletemodal] = useState(false);
  const [deleteId, setdeleteId] = useState(null);
  const [timezoneModal, setTimezoneModal] = useState(false);
  const [selectedTZ, setSelectedTZ] = useState("");
  const [currentTime, setCurrentTime] = useState("");
  const [appointments, setAppointments] = useState([]);
  const sampleAppointments = [
    { day: "Monday", timeUtc: "2025-06-02T14:00:00Z" },
    { day: "Wednesday", timeUtc: "2025-06-04T18:00:00Z" },
    { day: "Friday", timeUtc: "2025-06-06T16:30:00Z" },
  ];

  useEffect(() => {
    let timer;
    if (selectedTZ) {
      updateCurrentTime(selectedTZ);
      timer = setInterval(() => updateCurrentTime(selectedTZ), 1000);
      renderAppointments(selectedTZ);
    } else {
      setCurrentTime("");
      setAppointments([]);
    }
    return () => clearInterval(timer);
  }, [selectedTZ]);

  const updateCurrentTime = (tz) => {
    const now = DateTime.now().setZone(tz);
    setCurrentTime(`Current time in ${tz}: ${now.toFormat("ffff")}`);
  };

  const renderAppointments = (tz) => {
    const updated = sampleAppointments.map((appt) => {
      const localTime = DateTime.fromISO(appt.timeUtc, { zone: "utc" })
        .setZone(tz)
        .toFormat("hh:mm a");
      return { ...appt, localTime };
    });
    setAppointments(updated);
  };
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyAoF8F2jhZ_6-77oYJi0hgGTbcVh-CCIEE",
    libraries: ["places"],
  });
  const handleAddressSelection = () => {
    const selectedPlace = addressAutocomplete.getPlace();
  };
  const handleAddresstwoSelection = () => {
    const selectedPlace = addresstwoautocomplete.getPlace();
  };
  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const handleChange = (e) => {
    reset({
      phone: e,
    });
  };

  const onSubmit = async (data) => {
    console.log("form data ", data);
    data.agencyId = profiledata?._id;

    try {
      const response = await AddAddressbyagency(data);
      ShowToast(response?.data?.message);
      reset();
      FetchAddresslist();

      closeModal();
      GetTabStatus();
      setShowModal(false);
      console.log(response?.data?.data, "response=====");
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = (id) => {
    setdeleteId(id);
    setconfirmdeletemodal(true);
  };

  const confirmDelete = async () => {
    setconfirmdeletemodal(false);
    const data = {
      id: deleteId,
    };
    try {
      const response = await Deleteserviceaddress(data);

      if (response?.data?.success) {
        ShowToast(response?.data?.message);
        FetchAddresslist();
        GetTabStatus();
      } else {
        ShowToast("Error: Unable to delete address.");
      }
    } catch (error) {
      console.error("Delete operation failed:", error);
      ShowToast("An error occurred while deleting the address.");
    }
  };

  const Fetchclinic = async () => {
    try {
      const response = await GetPlaceservice();
      // console.log(response?.data?.data, "hello======");
      const data = response?.data?.data?.map((e) => {
        return {
          name: `${e.ServiceName} `,
          ...e,
        };
      });
      setPlacedata(data);
    } catch (error) {
      console.log(error);
    }
  };
  const FetchAddresslist = async () => {
    const data = {
      id: profiledata?._id,
    };
    try {
      const response = await Getserviceaddress(data);
      setaddressData(response?.data?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    Fetchclinic();
    FetchAddresslist();
  }, []);
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "90vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 4,
    outline: "none",
  };
  if (!isLoaded) return <div>Loading...</div>;

  return (
    <div
      style={{
        width: "100%",
        alignItems: "center",
        justifyItems: "center",
        marginBottom: 20,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <h1> Service Locations</h1>
        <div className="add-button_user" onClick={openModal}>
          Add Address
        </div>
      </div>

      <div style={{ overflowX: "auto", width: "100%", marginTop: 30 }}>
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Address 1</th>
              <th>Address 2</th>
              <th>City, State, Zip, Country</th>
              <th>Place of Service Code</th>
              <th>Location Timezone</th>
              <th>Phone</th>
              <th>Fax</th>
              <th>Email</th>
              <th>NPI</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {addressData.length === 0 ? (
              <tr>
                <td
                  colSpan="11"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No addresses found.
                </td>
              </tr>
            ) : (
              addressData.map((row, index) => (
                <tr key={index} style={tableRowStyle}>
                  <td style={tableCellStyle}>{row.name}</td>
                  <td style={tableCellStyle}>{row.address1}</td>
                  <td style={tableCellStyle}>{row.address2 || "N/A"}</td>
                  <td style={tableCellStyle}>
                    {row.city}, {row.state}, {row.zip}, {row.country}
                  </td>
                  <td style={tableCellStyle}>
                    <div style={{ whiteSpace: "pre-line" }}>
                      {row.serviceCode?.ServiceCodeNo} -{" "}
                      {row.serviceCode?.ServiceName}
                    </div>
                  </td>
                  <td style={tableCellStyle}>{row.locationTomeZone}</td>
                  <td style={tableCellStyle}>{row.phone}</td>
                  <td style={tableCellStyle}>{row.fax || "N/A"}</td>
                  <td style={tableCellStyle}>{row.email}</td>
                  <td style={tableCellStyle}>{row.npi}</td>
                  <td style={tableCellStyle}>
                    <button
                      className="action_icon_btn"
                      title="Delete"
                      onClick={() => handleDelete(row._id)}
                    >
                      <i class="fas fa-trash-alt" style={{ color: "black" }} />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Modal
        open={showModal}
        onClose={closeModal}
        aria-labelledby="modal-title"
      >
        <Box sx={modalStyle} className="Custom_servicer_modalMain">
          <form
            onSubmit={handleSubmit(onSubmit)}
            style={{
              width: "100%",
              alignItems: "center",
              justifyItems: "center",
              marginBottom: 20,
            }}
          >
            <h1 style={{ textAlign: "left" }}>New Service Location</h1>
            <div
              style={{
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Inputbox
                label="Name"
                type="text"
                placeholder="Enter Name"
                name="name"
                register={register}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {errors.name?.message}
              </p>
              <Autocomplete
                onLoad={(autocompleteInstance) =>
                  setAddressAutocomplete(autocompleteInstance)
                }
                onPlaceChanged={handleAddressSelection}
              >
                <Inputbox
                  label="Address 1"
                  type="text"
                  placeholder="Enter Address 1"
                  name="address1"
                  register={register}
                />
              </Autocomplete>
              <p style={{ color: "red", textAlign: "left" }}>
                {errors?.address1?.message}
              </p>
              <Autocomplete
                onLoad={(autocompleteInstance) =>
                  setaddresstwoautocomplete(autocompleteInstance)
                }
                onPlaceChanged={handleAddresstwoSelection}
              >
                <Inputbox
                  label="Address 2 (Optional)"
                  type="text"
                  placeholder="Enter Address 2"
                  name="address2"
                  register={register}
                />
              </Autocomplete>
              <Inputbox
                label="City"
                type="text"
                placeholder="Enter City"
                name="city"
                register={register}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {errors?.city?.message}
              </p>
              <Inputbox
                label="State"
                type="text"
                placeholder="Enter State"
                name="state"
                register={register}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {errors?.state?.message}
              </p>
              <Inputbox
                label="Zip"
                type="text"
                placeholder="Enter Zip"
                name="zip"
                register={register}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {errors?.zip?.message}
              </p>
              <Inputbox
                label="Country"
                type="text"
                placeholder="Enter Country"
                name="country"
                register={register}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {errors?.country?.message}
              </p>
              <DropDownManuCustom
                label="Place of Service Code (Type/Code)"
                placeholder="Select option"
                options={Placedata}
                name="serviceCode"
                dropdownicon
                register={register}
                id="_id"
                clearErrors={clearErrors}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {errors.serviceCode?.message}
              </p>{" "}
                  <DropDownManuCustom
                label="Location Timezone"
                placeholder="Select option"
                options={Locationdata}
                name="locationTomeZone"
                dropdownicon
                register={register}
                id="name"
                clearErrors={clearErrors}
              />
              {/* <Inputbox
                label="Location Timezone"
                type="text"
                placeholder="Enter Location Timezone"
                name="locationTomeZone"
                register={register}
                disabled
              /> */}
              {/* <div style={{ height: 20 }} />
              <div onClick={() => setTimezoneModal(true)}> */}
              {/* <label>{"Location Timezone"}</label>
                <div className="fake_input">Enter Location Timezone</div>
              </div> */}
              <p style={{ color: "red", textAlign: "left" }}>
                {errors.locationTomeZone?.message}
              </p>
              <Inputbox
                label="Phone"
                type="text"
                placeholder="Enter Phone"
                name="phone"
                register={register}
                onChange={handleChange}
                style={{ width: "100%" }}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {errors.phone?.message}
              </p>
              <Inputbox
                label="Fax (Optional)"
                type="text"
                placeholder="Enter Fax"
                name="fax"
                register={register}
              />
              <Inputbox
                label="Email"
                type="text"
                placeholder="Enter Email"
                name="email"
                register={register}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {errors.email?.message}
              </p>
              <Inputbox
                label="NPI"
                type="text"
                placeholder="Enter NPI"
                name="npi"
                register={register}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {errors.npi?.message}
              </p>
              <button
                type="submit"
                style={{ marginBottom: 50, alignSelf: "center" }}
                className="Save_buttonnn"
              >
                Submit
              </button>
            </div>
          </form>
        </Box>
      </Modal>
      {timezoneModal && (
        <div className="modal_private_pay">
          <div
            className="modal-content_private_pay"
            style={{ maxWidth: "100%", width: "40%" }}
          >
            <span
              className="close_private_pay"
              onClick={() => setTimezoneModal(false)}
            >
              ×
            </span>
            <div className="container_timezone">
              <h2 className="heading_timezone">Office Calendar</h2>
              <div style={{ display: "flex" }}>
                <label className="label_timezone">
                  Select Office Time Zone:
                </label>
                <select
                  className="select_timezone"
                  value={selectedTZ}
                  onChange={(e) => setSelectedTZ(e.target.value)}
                >
                  <option value="">-- Select Time Zone --</option>
                  <option value="America/New_York">
                    Eastern Time (New York)
                  </option>
                  <option value="America/Chicago">
                    Central Time (Chicago)
                  </option>
                  <option value="America/Denver">Mountain Time (Denver)</option>
                  <option value="America/Phoenix">
                    Mountain Time - No DST (Phoenix)
                  </option>
                  <option value="America/Los_Angeles">
                    Pacific Time (Los Angeles)
                  </option>
                </select>
              </div>
              {currentTime && (
                <div className="currentTime_timezone">{currentTime}</div>
              )}

              <table className="table_timezone">
                <thead>
                  <tr>
                    <th className="th_timezone">Day</th>
                    <th className="th_timezone">Appointment Time</th>
                  </tr>
                </thead>
                <tbody>
                  {appointments.map((appt, index) => (
                    <tr key={index}>
                      <td className="td_timezone">{appt.day}</td>
                      <td className="td_timezone">{appt.localTime}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {confirmdeletemodal && (
        <DeleteModal
          name="Service Address"
          onClose={() => setconfirmdeletemodal(false)}
          onConfirm={confirmDelete}
        />
      )}
    </div>
  );
};

export default AddAddress;
const tableHeaderStyle = {
  padding: "10px",
  borderBottom: "2px solid #ddd",
  textAlign: "left",
  fontWeight: "bold",
  backgroundColor: "#f4f4f4",
};

const tableCellStyle = {
  padding: "8px",
  borderBottom: "1px solid #ddd",
};

const tableRowStyle = {
  borderBottom: "1px solid #ddd",
};

const deleteButtonStyle = {
  backgroundColor: "red",
  color: "white",
  border: "none",
  borderRadius: "4px",
  padding: "5px 10px",
  cursor: "pointer",
};
